<footer class="footer mt-auto py-3  bg-light">
    <div class="container">
      <span class="text-primary text-center">
        
        جميع الحقوق محفوظة، شركة أنجم لتقنية المعلومات
    
    </span>
    </div>
  </footer>